var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9057 2.86021C20.1259 3.30957 19.9474 3.85599 19.5071 4.08068C15.8118 5.96688 13.8378 7.80438 11.9976 11.1569C11.7105 11.68 11.7105 12.32 11.9976 12.8431C13.8378 16.1956 15.8118 18.0331 19.5071 19.9193C19.9474 20.144 20.1259 20.6904 19.9057 21.1399C19.6856 21.5891 19.1504 21.7713 18.7102 21.5466C14.736 19.5181 12.4784 17.441 10.4428 13.7325C9.8524 12.6569 9.8524 11.3431 10.4428 10.2675C12.4784 6.559 14.736 4.48185 18.7102 2.45338C19.1504 2.2287 19.6856 2.41084 19.9057 2.86021Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9057 2.86021C13.1259 3.30957 12.9474 3.85599 12.5071 4.08068C8.81179 5.96688 6.8378 7.80438 4.99759 11.1569C4.71048 11.68 4.71048 12.32 4.99759 12.8431C6.8378 16.1956 8.81179 18.0331 12.5071 19.9193C12.9474 20.144 13.1259 20.6904 12.9057 21.1399C12.6856 21.5891 12.1504 21.7713 11.7102 21.5466C7.73603 19.5181 5.47842 17.441 3.44279 13.7325C2.8524 12.6569 2.8524 11.3431 3.44279 10.2675C5.47842 6.559 7.73603 4.48185 11.7102 2.45338C12.1504 2.2287 12.6856 2.41084 12.9057 2.86021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDouble);
export default __webpack_public_path__ + "static/media/Arrow-Left-Double.d7e0340f.svg";
export { ForwardRef as ReactComponent };